module.exports = __webpack_public_path__ + "img/37.265cca8c.png";